import { MediaUpload } from '@wordpress/block-editor';
import { Button } from '@wordpress/components';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
} = wp;

const PosterImage = ({ setAttributes, videoPosterImage }) => {
  return (
    <>
      <span className="title-label">{__('Poster Image', 'b3rg')}</span>
      <MediaUpload
        onSelect={(media) => {
          setAttributes({
            videoPosterImage: {
              id: media.id,
              title: media.title,
              filename: media.filename,
              url: media.url,
              fileType: media.type,
            },
          });
        }}
        type="image"
        allowedTypes={['image']}
        value={videoPosterImage.id}
        render={({ open }) => (
          <div className="media-upload image-upload">
            {videoPosterImage.url && (
              <div className="upload-buttons-wrapper">
                <MediaReplaceButton onClick={open} />
                <MediaRemoveButton
                  onClick={() => {
                    setAttributes({ videoPosterImage: {} });
                  }}
                />
              </div>
            )}
            {!videoPosterImage.url && (
              <Button className="media-button upload-button" onClick={open}>
                {__('Upload Image', 'b3rg')}
              </Button>
            )}
            {videoPosterImage.url && (
              <div
                className="image-thumb-wrapper"
                onClick={open}
                onKeyUp={open}
                role="button"
                tabIndex="0"
              >
                <img
                  className="image-thumb"
                  src={videoPosterImage.url}
                  alt=""
                />
              </div>
            )}
          </div>
        )}
      ></MediaUpload>
    </>
  );
};

export default PosterImage;
